<div class="row" style="margin:10px 0px;" *ngIf="_meta | async as meta">
  <div class="col-md-12">
    <div class="panel panel-default">
      <div class="panel-default">
        <div class="panel-heading" (click)="getItems()"
             style="cursor:pointer;">
          <h4 class="panel-title">
            <a role="button">
              <span *ngIf="loading"><i class="fa fa-spinner fa-pulse"></i></span>
              <i *ngIf="IsCollapsed && !loading && (items === undefined || items.length !== 0)"
                 class="pull-left fa fa-chevron-down"></i>
              <i *ngIf="!IsCollapsed && !loading && items !== undefined && items.length !== 0"
                 class="pull-left fa fa-chevron-up"></i>
              <span *ngIf="items !== undefined && items.length === 0 && !loading">No </span>
              <span *ngIf="!meta.verbose_name_plural">
                                {{ meta.verbose_name }}
                            </span>
              <span *ngIf="meta.verbose_name_plural">
                                {{ meta.verbose_name_plural }}
                            </span>
            </a>
            <div
              *ngIf="meta.permissions && meta.permissions.write && meta.type !== undefined && !disableAdd && !loading"
              class="pull-right">
                            <span style="cursor: pointer;" (click)="open(foreignKey, {}, $event)">
                                Add {{ meta.verbose_name }}
                              <i class="fa fa-plus-circle"></i>
                            </span>
            </div>
          </h4>
        </div>
      </div>
      <div class="panel-body" *ngIf="loading" [ngbCollapse]="IsCollapsed">
        <i class="fa fa-spinner fa-pulse"></i>
      </div>
      <div class="panel-body table-responsive" *ngIf="items !== undefined && items.length > 0 && !loading"
           [ngbCollapse]="IsCollapsed">
        <table class="table table-striped">
          <thead>
          <tr>
            <ng-template ngFor let-key [ngForOf]="meta.display_fields">
              <th
                *ngIf="meta.fields[key].type != 'field' || (meta.fields[key].type === 'field' && meta.fields[key].read_only === true)">
                {{ meta.fields[key].label }}
              </th>
            </ng-template>
            <th *ngIf="meta.permissions && meta.permissions.write && !disableDelete" style="width:25px">Delete</th>
          </tr>
          </thead>
          <!-- Moved ng-repeat from tbody to tr -->
          <tbody>
          <!-- This ng-repeat is for Contacts, Organizations, and Mailing Addresses -->
          <ng-template ngFor let-item [ngForOf]="items" let-index="index">
            <tr style="border: none;">
              <ng-template ngFor let-key [ngForOf]="meta.display_fields">
                <td [style]="(meta.permissions && meta.permissions.write) ? {'cursor': 'pointer'} : ''"
                    *ngIf="meta.fields[key].type != 'field' || (meta.fields[key].type === 'field' && meta.fields[key].read_only === true)"
                    (click)="meta.permissions && meta.permissions.write && open(foreignKey, item, $event) && meta.type !== undefined">
                  <app-display-field [type]="meta.fields[key].type" [value]="item[key]"
                                     [getChoices]="meta.fields[key].get_choices"
                                     [choices]="meta.fields[key].choices"></app-display-field>
                </td>
                <td *ngIf="meta.sort_attribute">{{ item[meta.sort_attribute] + 1 }}</td>

              </ng-template>
              <td *ngIf="meta.permissions && meta.permissions.write && !disableDelete"
                  style="vertical-align: middle; cursor: pointer;"
                  (click)="delete(item)">
                <i class="fa-regular fa-times-circle fa-lg" style="padding:0px 30%;"></i>
              </td>
            </tr>

            <tr  style="background: none; border: none;"
                *ngIf="meta.subItems && meta.subItems.length > -1">
              <td [attr.colspan]="meta.display_fields.length+1">
                <ng-template ngFor let-key [ngForOf]="meta.subItems">
                  <app-nested-inline [meta]="meta.fields[key]" [items]="item[key]"
                                     [foreignKey]="item.globalid"></app-nested-inline>
                </ng-template>
              </td>
            </tr>
          </ng-template>
          </tbody>
        </table>
        <div *ngIf="items === undefined && items.length < meta.count">
          <div class="row">
            <div class="col-md-12">
              <p class="text-center">
                <a role="button" class="text-center" (click)="loadMore()" *ngIf="!loadingMore">Load
                  More Records</a>
                <span *ngIf="loadingMore">
                        <i class="fa fa-spinner fa-pulse"></i>
                    </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
